export enum StartParamKey {
  INVITE = 'i',
  REFERAL = 'r',
  MODE = 'm',
  PAGE = 'p',
}
